import { selectLocationPathname, selectLocationSearch, useLocationSelector } from '@shared/core/router.helper/useLocationSelector';
import { useCardsRouterContext } from '@apps/card/Card.routes';
import { isBareGalleryUrl } from './galleryParams';

/**
 * True on a URL the server rendered the gallery for (PRNT-5494): the public shop's bare
 * `/cards/wedding/:category`. Mirrors the server gate in `publicGallerySsrGate.ts`; the two must
 * agree, or the client reproduces a different first render from the server's markup.
 */
export const useIsPublicGallerySsr = (): boolean => {
  const { isPublicShopRoute } = useCardsRouterContext();
  const pathname = useLocationSelector(selectLocationPathname);
  const search = useLocationSelector(selectLocationSearch);
  return isPublicShopRoute && isBareGalleryUrl(pathname, search);
};
